import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import globalStyles from './pc-image.lightDom.css.lit';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

/**
 * Image component
 * @element pc-image
 * @slot - This element has a default slot
 */
@customElement('pc-image')
export class PCImage extends OutlineElement {
  adoptedStylesheets: AdoptedStyleSheets;

  @property({ type: Boolean, attribute: 'has-right-radius' })
  hasRightRadius: boolean;

  @property({ type: Boolean, attribute: 'rounded-full' })
  roundedFull: boolean;

  @property({ type: Boolean, attribute: 'rounded-small' })
  roundedSmall: boolean;

  @property({ type: Boolean, attribute: 'rounded-medium' })
  roundedMedium: boolean;

  // Adds a width and height 100% style to the img
  @property({ type: Boolean, attribute: 'fill-container' })
  fillContainer: boolean;

  connectedCallback() {
    super.connectedCallback();

    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);

    const image = this.querySelector('img');

    if (image) {
      this.hasRightRadius && image.classList.add('has-right-radius');
      this.roundedFull && image.classList.add('rounded-full');
      this.roundedSmall && image.classList.add('rounded-small');
      this.roundedMedium && image.classList.add('rounded-medium');
      this.fillContainer && image.classList.add('w-full', 'h-full');
    }
  }

  render(): TemplateResult {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-image': PCImage;
  }
}
